module.exports = __webpack_public_path__ + "img/mlik_plan_bg1@2x.beb1cb1b.png";